import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updateStatusMediasToQualify = async ({ status, mediaIds, reason }) => {
  const body = {
    medias: mediaIds,
    status: status,
    reason: reason,
  };

  const response = await axiosInstance.patch('/medias/status/', body);
  return response.data;
};

export const useUpdateStatusMediasToQualify = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...options,
    mutationFn: updateStatusMediasToQualify,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['medias'] });

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
  });

  return {
    updateStatusMediasToQualify: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
